import React from "react";
import styled from "styled-components";
import emailjs from "@emailjs/browser";

import SuccessModal from "./SuccessModal";

export default function Contact() {
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  function sendEmail(e) {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_sa6lsaf",
        "template_xwxk3pu",
        e.target,
        "s8_LiEUF8-hQeIdRe"
      )
      .then(setShowSuccessModal(true));
  }

  return (
    <StyledForm onSubmit={sendEmail}>
      <StyledLabel htmlFor="name">Name:</StyledLabel>
      <StyledInput type="text" id="name" name="name" />

      <StyledLabel htmlFor="email">Email:</StyledLabel>
      <StyledInput type="email" id="email" name="email" />

      <StyledLabel htmlFor="cell">Cell:</StyledLabel>
      <StyledInput type="tel" id="cell" name="cell" />

      <StyledLabel htmlFor="company">Company:</StyledLabel>
      <StyledInput type="text" id="company" name="company" />

      <StyledLabel htmlFor="message-header">Message Header:</StyledLabel>
      <StyledInput type="text" id="message-header" name="message-header" />

      <StyledLabel htmlFor="message-body">Message Body:</StyledLabel>
      <StyledTextarea id="message-body" name="message-body"></StyledTextarea>

      <StyledButton type="submit">Submit</StyledButton>
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={handleCloseSuccessModal}
      />
    </StyledForm>
  );
}

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 400px;
  margin: 0 auto;
  color: #fff;
`;

const StyledLabel = styled.label`
  font-size: 1rem;
  font-weight: bold;
`;

const StyledInput = styled.input`
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #fff;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  color: #fff;

  &:focus {
    outline: none;
    border-bottom: 2px solid #fff;
  }
`;

const StyledTextarea = styled.textarea`
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #fff;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  color: #fff;
  resize: vertical;

  &:focus {
    outline: none;
    border-bottom: 2px solid #fff;
  }
`;

const StyledButton = styled.button`
  background-color: transparent;
  border: 2px solid #fff;
  border-radius: 0.25rem;
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #fff;
    color: #000;
  }

  &:focus {
    outline: none;
    box-shadow: 0px 0px 5px rgba(255, 255, 255, 0.5);
  }
`;
